import { AxiosError } from 'axios';
import { PUT_ADMIN_ANNOUNCEMENT_CONFIGS } from 'web-library/constants/apiUrls';
import { AnnouncementConfigs } from 'web-library/models/Announcements';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutAdminAnnouncementConfigs = ({ onSuccess, onError }: Input) => {
  const putAdminAnnouncementConfigs = async (announcementConfigs: AnnouncementConfigs) => {
    await axiosClient.put(PUT_ADMIN_ANNOUNCEMENT_CONFIGS, announcementConfigs);
  };

  return useCustomMutation(putAdminAnnouncementConfigs, {
    onSuccess,
    onError,
  });
};
